export enum PaymentsHistoryRoute {
  paymentsHistoryList = 'Payments History List',
  paymentsHistoryDetails = 'Payments History Details'
}
